import { TopAppBar } from "./AppBar";
import { useTheme } from "@mui/material/styles";
import { Sidebar } from "./Sidebar";
import { Outlet } from "react-router-dom";
import { memo, useCallback, useState } from "react";
import MenuIcon from "@mui/icons-material/Menu";
import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import Divider from "@mui/material/Divider";
import useMediaQuery from "@mui/material/useMediaQuery";
import IconButton from "@mui/material/IconButton";
import { useLocation } from "react-router-dom";
import { LoginDialog } from "../messaggi/LoginDialog";
import { Role, oraPrenotaStore } from "../oraPrenotaStore";
import { selectRole } from "../utils/selectors";

export const Dashboard = memo(function Dashboard() {
  const theme = useTheme();
  const large = useMediaQuery(theme.breakpoints.up("md"));
  const [drawerOpen, setDrawerOpen] = useState(false);
  const handleDrawerClose = useCallback(() => setDrawerOpen(false), [setDrawerOpen]);
  const role = oraPrenotaStore(selectRole);

  let location = useLocation();
  const publicPage = location.pathname.includes("public/prenotazione");
  const fullPage =
    location.pathname.includes("tabelloneTariffe") ||
    location.pathname.includes("app/statistiche") ||
    location.pathname.includes("app/listaTransazioni") ||
    location.pathname.includes("app/ricarica/pagamentiSatispay") ||
    publicPage;

  const openBtn = large ? (
    <></>
  ) : (
    <IconButton
      onClick={() => setDrawerOpen(!drawerOpen)}
      size="large"
      edge="start"
      color="inherit"
      aria-label="menu"
      sx={{ mr: 2 }}
    >
      <MenuIcon />
    </IconButton>
  );
  return (
    <Box
      height="100vh"
      sx={{
        display: "grid",
        gridTemplateRows: "64px auto",
        gridTemplateAreas: "'header' 'content'",
      }}
    >
      <Grid item gridArea="header">
        <TopAppBar openBtn={openBtn} />
      </Grid>
      <Grid item gridArea="content" overflow="auto" display={"flex"} flexDirection="row">
        {large && (
          <Box minWidth={publicPage ? 80 : 280} overflow="auto">
            <Sidebar />
          </Box>
        )}

        <Box overflow="auto" flexGrow={1} pt={[1, 1, 2]} pb={15}>
          {fullPage && (
            <Box paddingLeft={[1, 1, 2]}>
              <Outlet />
            </Box>
          )}
          {!fullPage && (
            <Container>
              <Outlet />
            </Container>
          )}
        </Box>
      </Grid>
      {!large && (
        <Drawer
          sx={{
            width: 280,
            flexShrink: 0,
            "& .MuiDrawer-paper": {
              width: 280,
            },
          }}
          open={drawerOpen}
          anchor="left"
          onClose={handleDrawerClose}
        >
          <Divider />
          <Sidebar close={handleDrawerClose} />
        </Drawer>
      )}
      {role === Role.USER && <LoginDialog />}
    </Box>
  );
});
